
let UnitConversions = require("../../cio-config/unitConversions.js");
let MetaProperties = require("../../cio-config/metaProperties.js");
let Types = require("../../cio-config/types.js");

let Properties = MetaProperties["package"];

const floatTolerance = 10; // um

class SearchModel {

    constructor(){}

    getProperties(){
        return [{displayTitle: 'Select Filter', description: '',serverName: 'Select Filter', defaultText: ''},
                ...Object.values(Properties)];
    }

    validate(input, item, onSearchPackages){
        let type = item.type;

        if(input.value === ""){
            input.dataset.valShadow = "";
            setTimeout(() => onSearchPackages(), 0);
            return;
        }

        let parseValue = type.parser(UnitConversions.trimUnit(input.value));

        if(type.validator(parseValue)){
            input.classList.remove("invalid");

            const value = this.makeValue(input, item);
            if (!value) {
                input.dataset.valShadow = "";
                input.classList.add("invalid");
            } else {
                input.dataset.valShadow = value;
            }

            setTimeout(() => onSearchPackages(), 0);
        }else{
            input.classList.add("invalid");
        }
    }

    makeValue(input, item){
        const inputValue = input.value;
        const { type } = item;
        const realValue = this.getRealValue(inputValue, item);

        if(type == Types.positive_float){
            if(realValue - floatTolerance < 0){
                return `[0,${realValue + floatTolerance}]`;
            } else {
                return `[${realValue - floatTolerance},${realValue + floatTolerance}]`;
            }
        } else if(type == Types.float){
            return `[${realValue - floatTolerance},${realValue + floatTolerance}]`;
        } else {
            return realValue;
        }
    }

    getRealValue(value, item){
        const { unit, type } = item
        if(unit && !type){
            value = UnitConversions.convert(unit, "um", value);
            if(!this.isValid(value)) return null;
            return value
        }
        else if(!unit && type){
            value = type.parser(value);
            value = encodeURIComponent(value);
            if(!this.isValid(value)) return null;
            return value
        }else if(unit && type && type.reader){
            if(!UnitConversions.hasUnit(value)) value = value + unit;
            value = type.reader(value, "um");
            if(!this.isValid(value)) return null;
            return value
        }else {
            // if here its an enum!
            return value;
        }
    }

    isValid(val) {
        if(typeof val != "string" && isNaN(val)){
            return false;
        } else if(val === null || val === 'NaN'){
            return false;
        } else {
            return true;
        }
    }

    addUnit(input, item) {
        if(input.value === "" || !item.unit){return}
        if(!UnitConversions.hasUnit(input.value)) input.value = input.value + item.unit;
    }
}

module.exports = new SearchModel();
